import React from 'react'
import PropTypes from 'prop-types'

import LastOrder from './../block/LastOrder'
import AkciiSlyder from './../block/AkciiSlyder'
import Footer from './../block/Footer'

import { Close } from './../block/Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      lastOrder,
      data,
      showFeedbackForm,
      assets_path,
      restaurant,
      cart,
      leftMenu
    } = this.props


    return (
      <div
        className='bg-cover bg-center bg-no-repeat'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container font-manrope tracking-tight min-h-dvh flex flex-col overflow-x-hidden'>
          <div className='flex items-center justify-between pt-[10px]'>
            <div className='w-[121px]'>
              <a href="/" className="flex-none w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center cursor-pointer">
                <Close />
              </a>
            </div>
            <div className='text-center font-manrope text-[22px] text-black font-semibold'>
              Акции
            </div>
            <div onClick={() => showFeedbackForm()} className="flex-none gap-[7px] w-[121px] h-[40px] rounded-full bg-white flex items-center justify-center cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.8534 12.6225L14.1459 14.9925C14.2209 15.615 13.5534 16.05 13.0209 15.7275L9.87836 13.86C9.53336 13.86 9.19587 13.8375 8.86587 13.7925C9.42087 13.14 9.75086 12.315 9.75086 11.4225C9.75086 9.29249 7.90586 7.56752 5.62586 7.56752C4.75586 7.56752 3.95337 7.815 3.28587 8.25C3.26337 8.0625 3.25586 7.87499 3.25586 7.67999C3.25586 4.26749 6.21836 1.5 9.87836 1.5C13.5384 1.5 16.5009 4.26749 16.5009 7.67999C16.5009 9.70499 15.4584 11.4975 13.8534 12.6225Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9.75 11.4225C9.75 12.315 9.42001 13.14 8.86501 13.7925C8.12251 14.6925 6.945 15.27 5.625 15.27L3.6675 16.4325C3.3375 16.635 2.9175 16.3575 2.9625 15.975L3.15 14.4975C2.145 13.8 1.5 12.6825 1.5 11.4225C1.5 10.1025 2.205 8.93998 3.285 8.24998C3.9525 7.81498 4.755 7.5675 5.625 7.5675C7.905 7.5675 9.75 9.29247 9.75 11.4225Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className='text-[14px] text-black'>Связаться</div>
            </div>
          </div>
          <LastOrder
            order={lastOrder}
            assets_path={assets_path}
          />

          <AkciiSlyder
            slydes={restaurant?.akcii || []}
            full={true}
          />

          <div className='w-[100%] h-[90px]' />
          <Footer
            showFeedbackForm={showFeedbackForm}
            data={data}
            cart={cart}
            leftMenu={leftMenu}
          />

        </div>
      </div>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  data: PropTypes.object,
  showFeedbackForm: PropTypes.func,
  lastOrder: PropTypes.object,
  restaurant: PropTypes.object,
  cart: PropTypes.object,
  leftMenu: PropTypes.func
}

export default Main